import { InjectionFeature, RewardItem } from '@/common/reward/types';
import { useCrudActions } from '@/common/view/useCrudActions';
import { liveopsPointService } from '@/services/liveops';
import { computed, Ref, ref } from 'vue';

export function useLiveopsReward(selectedFeature?: Ref<number | InjectionFeature>) {
    const linkableRewards = ref<RewardItem[]>([]);

    const fetchLinkableRewards = useCrudActions().executeAction({
        request: liveopsPointService.reward.getLinkableItems,
        onSuccess: ({ data }) => void (linkableRewards.value = data),
        onError: () => void (linkableRewards.value = [])
    });

    const rewardOptions = computed(() => {
        if (!selectedFeature) return [];

        return linkableRewards.value
            .filter(item => item.feature === selectedFeature.value)
            .map(item => ({ value: item.itemId, label: item.itemName }));
    });

    return { linkableRewards, fetchLinkableRewards, rewardOptions };
}
